import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DeviceNotSupportedComponent } from './device-not-supported.component';
import { AppRoutesName } from '../../const/AppRoutesName';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { GenericAlertComponent } from '../../components/generic-alert/generic-alert.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DEVICE_NOT_SUPPORTED,
    component: DeviceNotSupportedComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.DEVICE_NOT_SUPPORTED,
    component: DeviceNotSupportedComponent,
  },
];

@NgModule({
  declarations: [DeviceNotSupportedComponent],
  imports: [
    GenericAlertComponent,
    MatButtonModule,
    MatInputModule,
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    TranslateModule.forRoot(),
    MatFormFieldModule,
    MatCardModule,
  ],
  exports: [DeviceNotSupportedComponent],
  providers: [],
})
export class DeviceNotSupportedModule {}
